$(document).ready(function() {

    if ($('#ttgNCEHeaderSlider .item.active div.fontColor_grau').length) {
        $('#ttgNCEHeaderSlider').addClass('controlsColor_grau');
    } else {
        $('#ttgNCEHeaderSlider').addClass('controlsColor_weiss');
    }

    if ($('#ttgNCEHeader div.fontColor_grau').length) {
        $('#ttgNCEHeader').addClass('controlsColor_grau');
    } else {
        $('#ttgNCEHeader').addClass('controlsColor_weiss');
    }

    $('#ttgNCEHeaderSlider').on('slide.bs.carousel', function(e) {
        $('#ttgNCEHeaderSlider').removeClass('controlsColor_grau').removeClass('controlsColor_weiss');
        if ($(e.relatedTarget).find('div.fontColor_grau').length) {
            $('#ttgNCEHeaderSlider').addClass('controlsColor_grau');
        } else {
            $('#ttgNCEHeaderSlider').addClass('controlsColor_weiss');
        }
    });

    // pause and play buttons for automatic sliding
    $('#ttgNCEHeaderSlider .carousel-control.play').click(function(e) {
        e.preventDefault();
        $('#ttgNCEHeaderSlider').carousel('cycle');
        $(this).hide();
        $('#ttgNCEHeaderSlider .carousel-control.pause').show();
    });

    $('#ttgNCEHeaderSlider .carousel-control.pause').click(function(e) {
        e.preventDefault();
        $('#ttgNCEHeaderSlider').carousel('pause');
        $(this).hide();
        $('#ttgNCEHeaderSlider .carousel-control.play').show();
    });

    // pause when manually sliding
    $('#ttgNCEHeaderSlider .carousel-control.left, #ttgNCEHeaderSlider .carousel-control.right').click(function(e) {
        $('#ttgNCEHeaderSlider').carousel('pause');
        $('#ttgNCEHeaderSlider .carousel-control.pause').hide();
        $('#ttgNCEHeaderSlider .carousel-control.play').show();
    });

    // hide not active slides and set current indicator as current
    $("#ttgNCEHeaderSlider").on('slide.bs.carousel', function(e) {
        $(this).find('.carousel-indicators .active').removeAttr('aria-current');
        $(this).find('.item.active').attr('aria-hidden', 'true');
    });
    $("#ttgNCEHeaderSlider").on('slid.bs.carousel', function() {
        $(this).find('.carousel-indicators .active').attr('aria-current', 'true');
        $(this).find('.item.active').removeAttr('aria-hidden');
        $(this).find('.liveregion').text($(this).find('.liveregion').data('item') + " " + ($(this).find('.item.active').data('index') + 1) + " " + $(this).find('.liveregion').data('from') + " " + $(this).find('.liveregion').data('all'));
    });

});